import {
  USER_LIST_ACTIONS, USER_EDIT_ACTIONS, USER_DELETEIMAGE_ACTIONS, USER_DETAIL_ACTIONS, USER_DELETEMYACCOUNT_ACTIONS, PROFILE_IMAGE_ACTION, USER_EDIT_DETAIL_ACTIONS, USER_FOLLOWING_ACTION, USER_UNFOLLOWING_ACTION
} from "../../actionType/users";
import { VIEW_USER_DETAIL_ACTIONS } from "../../actionType/users";

const intialState = {
  userListData: [],
  isUsersListLoader: false,
  userDetailData: {},
  isUsersDetailLoader: false,
  viewUserDetailData: {},
  isViewUsersDetailLoader: false,
  userFollowingData: [],
  isUsersFollowingLoader: false,
  userUnFollowingData: [],
  isUsersUnFollowingLoader: false,
  userDetailEditData: [],
  isUsersDetailEditLoader: false,
  profileImage: "",
  isProfileImageLoader: false,
  userEditData: {},
  isUsersEditLoader: false,
  userDeleteMyAccount: {},
  isuserDeleteMyAccount: false,
  userDeleteImage: {},
  isuserDeleteImage: false,

};

export const usersReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case USER_LIST_ACTIONS.USER_LIST_REQUEST:
      return { ...state, isUsersListLoader: true };
    case USER_LIST_ACTIONS.USER_LIST_RESPONSE:
      return {
        ...state,
        userListData: payload,
        isUsersListLoader: false,
      };
    case USER_LIST_ACTIONS.USER_LIST_ERROR:
      return {
        ...state,
        userListData: payload,
        isUsersListLoader: false,
      };
    // MYPROFILE_DETAILS_FOR_USER
    case USER_DETAIL_ACTIONS.USER_DETAIL_REQUEST:
      return { ...state, isUsersDetailLoader: true };
    case USER_DETAIL_ACTIONS.USER_DETAIL_RESPONSE:
      return {
        ...state,
        userDetailData: payload,
        isUsersDetailLoader: false,
      };
    case USER_DETAIL_ACTIONS.USER_DETAIL_ERROR:
      return {
        ...state,
        userDetailData: payload,
        isUsersDetailLoader: false,
      };
    // VIEW_DETAIL_ACTIONS
    case VIEW_USER_DETAIL_ACTIONS.VIEW_USER_DETAIL_REQUEST:
      return { ...state, isViewUsersDetailLoader: true };
    case VIEW_USER_DETAIL_ACTIONS.VIEW_USER_DETAIL_RESPONSE:
      return {
        ...state,
        viewUserDetailData: payload,
        isViewUsersDetailLoader: false,
      };
    case VIEW_USER_DETAIL_ACTIONS.VIEW_USER_DETAIL_ERROR:
      return {
        ...state,
        viewUserDetailData: payload,
        isViewUsersDetailLoader: false,
      };
    // PROFILE_IMAGE_ACTION
    case PROFILE_IMAGE_ACTION.PROFILE_IMAGE_REQUEST:
      return {
        profileImage: payload,
        isProfileImageLoader: false,
      };
    // USER_FOLLOWING_LIST
    case USER_FOLLOWING_ACTION.USER_FOLLOWING_REQUEST:
      return { ...state, isUsersFollowingLoader: true };
    case USER_FOLLOWING_ACTION.USER_FOLLOWING_RESPONSE:
      return {
        ...state,
        userFollowingData: payload,
        isUsersFollowingLoader: false,
      };
    case USER_FOLLOWING_ACTION.USER_FOLLOWING_ERROR:
      return {
        ...state,
        userFollowingData: payload,
        isUsersFollowingLoader: false,
      };
    // USER_UNFOLLOWING_ACTION
    case USER_UNFOLLOWING_ACTION.USER_UNFOLLOWING_REQUEST:
      return { ...state, isUsersUnFollowingLoader: true };
    case USER_UNFOLLOWING_ACTION.USER_UNFOLLOWING_RESPONSE:
      return {
        ...state,
        userUnFollowingData: payload,
        isUsersUnFollowingLoader: false,
      };
    case USER_UNFOLLOWING_ACTION.USER_UNFOLLOWING_ERROR:
      return {
        ...state,
        userUnFollowingData: payload,
        isUsersUnFollowingLoader: false,
      };

    //USER_EDIT_ACTION
    case USER_EDIT_ACTIONS.USER_EDIT_REQUEST:
      return { ...state, isUsersEditLoader: true };
    case USER_EDIT_ACTIONS.USER_EDIT_RESPONSE:
      return {
        ...state,
        userEditData: payload,
        isUsersEditLoader: false,
      };
    case USER_EDIT_ACTIONS.USER_EDIT_ERROR:
      return {
        ...state,
        userEditData: payload,
        isUsersEditLoader: false,
      };
    //USER_PROFILE_EDIT
    case USER_EDIT_DETAIL_ACTIONS.USER_EDIT_DETAIL_REQUEST:
      return { ...state, isUsersDetailEditLoader: true };
    case USER_EDIT_DETAIL_ACTIONS.USER_EDIT_DETAIL_RESPONSE:
      return {
        ...state,
        userDetailEditData: payload,
        isUsersDetailEditLoader: false,
      };
    case USER_EDIT_DETAIL_ACTIONS.USER_EDIT_DETAIL_ERROR:
      return {
        ...state,
        userDetailEditData: payload,
        isUsersDetailEditLoader: false,
      };
    //USER_DELETE_MY_ACCOUNT
    case USER_DELETEMYACCOUNT_ACTIONS.USER_DELETEMYACCOUNT_REQUEST:
      return { ...state, isuserDeleteMyAccount: true };
    case USER_DELETEMYACCOUNT_ACTIONS.USER_DELETEMYACCOUNT_RESPONSE:
      return {
        ...state,
        userDeleteMyAccount: payload,
        isuserDeleteMyAccount: false,
      };
    case USER_DELETEMYACCOUNT_ACTIONS.USER_DELETEMYACCOUNT_ERROR:
      return {
        ...state,
        userDeleteMyAccount: payload,
        isuserDeleteMyAccount: false,
      };
    //USER_DELETE_MY_ACCOUNT
    case USER_DELETEIMAGE_ACTIONS.USER_DELETEIMAGE_REQUEST:
      return { ...state, isuserDeleteImage: true };
    case USER_DELETEIMAGE_ACTIONS.USER_DELETEIMAGE_RESPONSE:
      return {
        ...state,
        userDeleteImage: payload,
        isuserDeleteImage: false,
      };
    case USER_DELETEIMAGE_ACTIONS.USER_DELETEIMAGE_ERROR:
      return {
        ...state,
        userDeleteImage: payload,
        isuserDeleteImage: false,
      };


    default:
      return state;
  }
};
